import { nextfetch } from '@/shared/api/nextfetch'
import { ServerResponse } from '@/shared/types/common'

import { TCartItem } from '../../types/cart-item'

export const removeItemsFromCart = async (listString: string): Promise<TCartItem[] | void> => {
	await nextfetch<ServerResponse<TCartItem[]>>(`/basket?${listString}`, {
		method: 'DELETE'
	})
}
